import { __decorate, __metadata } from 'tslib';
import { Input, Component, NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';

let UiCTimelineComponent = class UiCTimelineComponent {
    constructor() {
        this.currentPage = 1;
    }
    /**
     * recebe o valor da pagina que esta atualmente
     */
    set current(input) {
        if (input !== null || input !== undefined) {
            this.currentPage = input;
        }
    }
    ngOnInit() { }
    /**
     * checa qual opcao que deve ser apresentada (hightlight)
     * @param pageNumber
     */
    highlight(pageNumber) {
        return (this.currentPage >= pageNumber) ? true : false;
    }
};
__decorate([
    Input('current'),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], UiCTimelineComponent.prototype, "current", null);
UiCTimelineComponent = __decorate([
    Component({
        selector: 'ui-c-timeline',
        template: "<ul class=\"timeline mx-auto\">\n  <li [ngClass]=\"{'is-active': highlight(1)}\" class=\"step py-2\">\n    <span class=\"step-number d-flex ion-align-items-center ion-justify-content-center\">1</span>\n    <p>{{ 'ONBORDING.CREATE_ACCOUNT.TIME_LINE.STEP_01' | wlpTranslate }}</p>\n  </li>\n  <li [ngClass]=\"{'is-active': highlight(2)}\" class=\"step py-2\">\n    <span class=\"step-number d-flex ion-align-items-center ion-justify-content-center\">2</span>\n    <p>{{ 'ONBORDING.CREATE_ACCOUNT.TIME_LINE.STEP_02' | wlpTranslate }}</p>\n  </li>\n  <li [ngClass]=\"{'is-active': highlight(3)}\" class=\"step py-2\">\n    <span class=\"step-number d-flex ion-align-items-center ion-justify-content-center\">3</span>\n    <p>{{ 'ONBORDING.CREATE_ACCOUNT.TIME_LINE.STEP_03' | wlpTranslate }}</p>\n  </li>\n  <li [ngClass]=\"{'is-active': highlight(4)}\" class=\"step py-2\">\n    <span class=\"step-number d-flex ion-align-items-center ion-justify-content-center\">4</span>\n    <p>{{ 'ONBORDING.CREATE_ACCOUNT.TIME_LINE.STEP_04' | wlpTranslate }}</p>\n  </li>\n  <li [ngClass]=\"{'is-active': highlight(5)}\" class=\"step py-2\">\n    <span class=\"step-number d-flex ion-align-items-center ion-justify-content-center\">5</span>\n    <p>{{ 'ONBORDING.CREATE_ACCOUNT.TIME_LINE.STEP_05' | wlpTranslate }}</p>\n  </li>\n</ul>\n",
        styles: [""]
    }),
    __metadata("design:paramtypes", [])
], UiCTimelineComponent);

let UiCTimelineModule = class UiCTimelineModule {
};
UiCTimelineModule = __decorate([
    NgModule({
        declarations: [UiCTimelineComponent],
        imports: [
            IonicModule,
            CommonModule,
            UiBsTranslateModule
        ],
        exports: [UiCTimelineComponent]
    })
], UiCTimelineModule);

export { UiCTimelineComponent, UiCTimelineModule };
//# sourceMappingURL=wlp-ui-c-timeline.js.map
